import { PropsWithChildren } from 'react'

type HeroCtaContainerProps = PropsWithChildren

export const HeroCtaContainer = ({ children }: HeroCtaContainerProps) => {
  return (
    <div className='w-full sm:max-w-60 md:max-w-max flex flex-col md:flex-row gap-3 md:gap-6'>
      {children}
    </div>
  )
}
